export class EquipmentLogbookImportModel {
    counter: number = 0;
    articleCode: number = 0;
    consecutive: number = 0;
    typeDocumentId: number = 0;
    providerDocument: string = "";
    invoiceNumber: string | null = null;
    purchaseDate: Date = new Date();
    purchaseValue: number = 0;
    trademark: string | null = null;
    commercialName: string = "";
    reference: string = "";
    serie: string = "";
    yearManufacture: number | null = null;
    warrantyInitialDate: Date | null = null;
    warrantyFinalDate: Date | null = null;
    equipmentType: string | null = "";
    voltage: string | null = null;
    power: string | null = null;
    amperage: string | null = null;
    capacity: string | null = null;
    engineType: string | null = null;
    engineCode: string | null = null;
    trademarkEngine: string | null = null;
    referenceEngine: string | null = null;
    serieEngine: string | null = null;
    observation: string | null = null;
    unitCode: string | null = null;
    maintenanceFrequency: number | null = null;
    tolerance: number | null = null;

    constructor(
        counter: number,
        articleCode: number,
        consecutive: number,
        typeDocumentId: number,
        providerDocument: string,
        invoiceNumber: string | null,
        purchaseDate: Date,
        purchaseValue: number,
        trademark: string | null,
        commercialName: string,
        reference: string,
        serie: string,
        yearManufacture: number | null,
        warrantyInitialDate: Date | null,
        warrantyFinalDate: Date | null,
        equipmentType: string | null,
        voltage: string | null,
        power: string | null,
        amperage: string | null,
        capacity: string | null,
        engineType: string | null,
        engineCode: string | null,
        trademarkEngine: string | null,
        referenceEngine: string | null,
        serieEngine: string | null,
        observation: string | null,
        unitCode: string | null,
        maintenanceFrequency: number | null,
        tolerance: number | null,
    ) {
        this.counter = counter;
        this.articleCode = articleCode;
        this.consecutive = consecutive;
        this.typeDocumentId = typeDocumentId;
        this.providerDocument = providerDocument;
        this.invoiceNumber = invoiceNumber;
        this.purchaseDate = purchaseDate;
        this.purchaseValue = purchaseValue;
        this.trademark = trademark;
        this.commercialName = commercialName;
        this.reference = reference;
        this.serie = serie;
        this.yearManufacture = yearManufacture;
        this.warrantyInitialDate = warrantyInitialDate;
        this.warrantyFinalDate = warrantyFinalDate;
        this.equipmentType = equipmentType;
        this.voltage = voltage;
        this.power = power;
        this.amperage = amperage;
        this.capacity = capacity;
        this.engineType = engineType;
        this.engineCode = engineCode;
        this.trademarkEngine = trademarkEngine;
        this.referenceEngine = referenceEngine;
        this.serieEngine = serieEngine;
        this.observation = observation;
        this.unitCode = unitCode;
        this.maintenanceFrequency = maintenanceFrequency;
        this.tolerance = tolerance;
    }
}